Directives.HomeCardSetupGuideStreamlined = function HomeCardSetupGuideStreamlined()  {

    // @ngInject
    function HomeCardSetupGuideStreamlinedConstructor(
        $injector,
        $scope,
        $timeout,
        $translate,
        $state,
        AnalyticsService,
        DeviceService,
        EventService,
        HomeService,
        SetupGuideService,
        UiPersistenceService,
        AppStates,
        $,
        _,
    ) {
        // Preamble
        //_________________________________________________

        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'HomeCardSetupGuideStreamlined';

        this.$timeout = $timeout;
        this.$translate = $translate;
        this.$state = $state;

        this.$ = $;
        this._ = _;

        this.AnalyticsService = AnalyticsService;
        this.DeviceService = DeviceService;
        this.EventService = EventService;
        this.HomeService = HomeService;
        this.SetupGuideService = SetupGuideService;
        this.UiPersistenceService = UiPersistenceService;
        this.AppStates = AppStates;

        // Utilities
        //_________________________________________________

        this.SetupGuideService.completeStepByKey('companyInfo');
        this.SetupGuideService.checkIfCompanyHasLogo();

        // the steps with checkmarks
        this.mainSteps = this._.where(
            this.SetupGuideService.steps, { listKey: "exploreItems" }
        );
        // the non-indexed last steps
        this.finalSteps = this._.where(
            this.SetupGuideService.steps, { listKey: "headerItems" }
        );

        // The "next" step is the first incomplete step. This only changes on
        // step completion.
        this.nextStep = this.SetupGuideService.getNextStreamlinedStep();

        // The "active" step is the step displayed in the UI which the user can freely
        // change. By default, the active step is the next step until the user clicks around
        this.activeStep = this.nextStep;

        if (this.activeStep.key === 'createProject') {
            this.SetupGuideService.animateCreateEvent();
        }

        const isFinalStep =
            ['createProject', 'becomeMember'].includes(this.activeStep.key);

        if (isFinalStep) {
            this.activeStep.isFinalStep = true;
            this.activeStep.finalStepHeadline = 'HOME.STREAMLINED_CARD.FINAL_STEP._HEADLINE_';
            this.mainSteps.push(this.activeStep);
        }

        this.AnalyticsService.trackPageView(
            this,
            this.AnalyticsService.analytics_events.setup_guide,
            {
                setup_guide_variant: this.SetupGuideService.setupGuideType,
            }
        );
    };

    var HomeCardSetupGuideStreamlinedController = Class(Controllers.BaseController, {
        constructor: HomeCardSetupGuideStreamlinedConstructor,

        calcCompleted: function calcCompleted() {
            this.activeStep = this.SetupGuideService.getNextStreamlinedStep();
        },

        onStepCTAClick: function onStepCTAClick(event, step) {
            event.preventDefault();
            event.stopPropagation();

            this.AnalyticsService.trackClick(this, this.AnalyticsService.analytics_events.setup_guide_modal_task, {
                type: step.listKey === 'exploreItems' ? 'explore' : 'customize',
                setup_task: step.key,
                completion: this.SetupGuideService.completedDonut(),
                is_completed: step.isComplete,
                setup_guide_variant: this.SetupGuideService.setupGuideType,
                position: step.orderStreamlined
            });

            if (!step.isComplete && !step.disableAutoCompleteTask) {
                this.$timeout(() => {
                    this.SetupGuideService.completeStep(step);
                    this.calcCompleted();
                }, 1000);
            }

            if (step.clickHandler && angular.isFunction(step.clickHandler)) {
                step.clickHandler();
            }

        },

        currStepIsActiveStep(step) {
            return Boolean(step && this.activeStep && step.key === this.activeStep.key);
        },

        gotToAccountSetup: function gotToAccountSetup(){
            this.AnalyticsService.trackClick(this, "account setup", {cta_location:"main setup card", setup_task: "accountSetup"});
            this.$state.go(this.AppStates.root_core_accountSetup);
        },

        handleStepClick: function handleStepClick(step) {
            if (this.currStepIsActiveStep(step)) {
                // do nothing if clicked on the active step
                return;
            }

            this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.toggle_setup_guide_modal_task, {
                setup_task: step.key,
                setup_guide_variant: this.SetupGuideService.setupGuideType
            });

            this.isTransitioning = true;
            this.$timeout(() => {
                this.activeStep = step;
                this.isTransitioning = false;
            }, 100);
        },

        onStepSecondaryCTAClick: function onStepSecondaryCTAClick(step) {
            if (step.secondaryClickHandler && angular.isFunction(step.secondaryClickHandler)) {
                step.secondaryClickHandler();
            }
        },

        handleCollapse: function handleCollapse() {
            this.isCollapsed = !this.isCollapsed;

            var $slideTarget = this.$('.js-home-sgs-slide-target');
            if (this.isCollapsed) {
                $slideTarget.slideUp(500);
            } else {
                $slideTarget.slideDown(500);
            }

            this.SetupGuideService.setPersistenceHomeOnboardingCard({ isCollapsed: this.isCollapsed });
        },
    });

    return {
        scope: {
            isCollapsed: '=',
        },
        templateUrl: 'angular/app/modules/core/features/home/home_card_setup_guide_streamlined/home_card_setup_guide_streamlined.html',
        controller: HomeCardSetupGuideStreamlinedController,
        controllerAs: 'homeSetupStreamlinedVm',
        bindToController: true
    };
};
